import React, { useRef, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Chip, Typography, Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import SearchSelectField from 'src/components/widgets/search-select-field';
import DateAndTimePicker from 'src/components/widgets/date-time-picker';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import SingleImageUploader from 'src/components/uploads/image-uploader';
import { assetsApi } from 'src/api/assets/vm-view';
import { setDefaultImageFromObj } from 'src/components/formik-utils';
import useForms from 'src/api/repairs/vm-form';
import useToast from 'src/utils/toast-utils';

import {
  validationPagers,
  pagersSubmitted,
} from './formik';

export const PagersView = ({ item, services = [], options = [], ...other }) => {
  const pickerRef = useRef();
  const pagersRef = useRef();
  const [element, setElement] = useState({ isRequired: true, imgTemp: 0, expTemp: 0 });
   
  const { editPagers } = useForms();
  const { toastSuccess, toastError } = useToast();

  // const validationSchema = useMemo(
  //   () => validationPagers(element.isRequired),
  //   [element.isRequired]
  // );

  // const initialValues = useMemo(() => ({
  //   image: null,
  //   pagersField: null,
  //   expField:null,
  // }), [item]);

  const formik = useCustomFormik({
    enableReinitialize: true,
    // initialValues,
    // validationSchema,
    initialValues: { image: null, pagersField: null, expField: null },
    validationSchema: validationPagers(element.isRequired),

    onSubmit: async (values) => {
      // console.log('==== value', values);
      values.carId = item.id;
      values.plate = item.plate;
      if(element.value){
        values.serviceId = element.value;
      }
      if(values.expField)

      await pagersSubmitted(values, editPagers, 
        (result, error) => {
          if(result) {
            toastSuccess(`Đã cập nhật (${element.label})`, {action: 'refresh'});
            resetForm(result);
          }
          else toastError(error);
        });
    },
  });

  const resetForm = (item) => {
    setElement({ isRequired: true, imgTemp: item.assetId });
    pickerRef.current?.reset?.();
    pagersRef.current?.reset?.();

    setDefaultImageFromObj(formik, null);
    formik.resetForm({
      values: {
        image: null,
        pagersField: null,
        expField: null,
      },
      // optional: clear errors and touched
      errors: {},
      touched: {},
    });
  };

  const [loading, setLoading] = useState(false);
  const handleChipClicked = (item) => {
    // console.log('handleChipClicked: ', item);

    const assetId = item.assetId;
    if(assetId > 0){
      setLoading(true);
      assetsApi.getAssetFileById(assetId, 
        (result) => {
          const object = {id: assetId, name: `${result.fileName}`};
          setDefaultImageFromObj(formik, object);
          setLoading(false);
        });
    }else{
      setDefaultImageFromObj(formik, null);
    }

    let seconds = 0;
    if(assetId > 0){
      seconds = item.expOn;
      setElement(prev => ({
        ...prev,
        isRequired: false,
        imgTemp: assetId,

        value: item.labelId,
        label: item.label,
        expOn: seconds,
      }));
    }else{
      seconds = 0;
      setElement(({ value, label, expOn, ...rest }) => ({
        ...rest,
        isRequired: true,
        imgTemp: 0
      }));
    }
    formik.setFieldValue('expField', seconds);
    formik.setErrors({});
  };

  return (
    <form onSubmit={formik.handleSubmit} {...other}>
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3}>
          <Grid xs={12} md={6}>
            <><Grid container spacing={3}>
              <Grid xs={12} md={12}>
                <ReadOnlyTextField label="Biển số" value={item.plate}/>
              </Grid>
              <Grid xs={12} md={12}>
              {services.map((element, idx) => (
                <Chip
                  key={idx}
                  clickable
                  onClick={() => handleChipClicked(element)}
                  label={
                    <Typography
                      component="span"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.95rem',
                        width: '100%',
                      }}
                    >
                      {element.label}:{' '}
                      <Typography
                        component="span"
                        sx={{ fontSize: '1.1rem', ml: 0.5 }}
                        color={element.color}
                      >
                        {element.value}
                      </Typography>
                    </Typography>
                  }
                  sx={{
                    maxWidth: '100%',
                    m: 1,
                    justifyContent: 'center',
                  }}
                />
              ))}
              </Grid>
            
              <Grid xs={12} md={12}>
                <SearchSelectField
                  ref={pagersRef}
                  label="Loại giấy tờ"
                  name="pagersField"
                  formik={formik}
                  options={options}
                  hintValue={element.label}
                  onSelected={(obj) => {
                    const has18 = obj?.value?.includes?.(18);  
                    const seconds = has18 ? 2524586400 : element?.expTemp;
                    
                    setElement(prev => ({
                      ...prev,
                      value: obj?.value,
                      label: obj?.label,
                      imgTemp: 0,
                      expOn: seconds,
                    }));

                    console.log('=====', seconds, has18);

                    setDefaultImageFromObj(formik, null);
                    formik.setFieldValue('expField', seconds);
                    formik.setErrors({});
                  }}
                />
              </Grid>

              <Grid xs={12} md={12}>
                <DateAndTimePicker
                  ref={pickerRef}
                  //key={element.expTemp ?? 'exp-reset'} // forces reset
                  label="Ngày hết hạn"
                  name="expField"
                  formik={formik}
                  ignoreDefault={true}
                  hintValue={element.expOn}
                  onDateChanged={(val) => {
                    setElement(prev => ({
                      ...prev,
                      expTemp: val,
                    }));
                  }}
                />
              </Grid>
            </Grid>
            </>
          </Grid>

          <Grid xs={12} md={6} style={{ position: 'relative' }}>
            <SingleImageUploader formik={formik} key={element.imgTemp ?? 'img-reset'} />
            {loading && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10,
                  borderRadius: 1,
                }}
              >
                <Typography variant="subtitle2">
                  Đang tải ảnh...
                </Typography>
              </Box>
            )}
          </Grid>
          <Grid xs={12} md={6} display="flex"
            sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}
          >
            <SubmitButton formik={formik} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
    </form>
  );
};

PagersView.propTypes = {
  item: PropTypes.object.isRequired,
  services: PropTypes.array,
  options: PropTypes.array,
};